import {Component, Input} from '@angular/core';
import {LotteryPage} from "../../../pages/lottery/lottery";
import {SixMarkBaseComponent} from "../sixMarkBase";

@Component({
  selector: 'sm-49-numbers',
  templateUrl: 'sixMark49Numbers.html'
})

/**
 * mname: SM01
 */
export class SixMark49NumbersComponent extends SixMarkBaseComponent {
  // List of numbers - each has value and isActive props
  numbers = [];
  // List of button options
  btnOptions = [];

  @Input()
  set selectOption(selectOption: any) {
    if (selectOption) {
      this.btnOptions = selectOption.no.btnOptions;

      // clear numbers array
      this.numbers.splice(0);

      // init numbers
      this.numbers = this.initNumbersArray(selectOption.no.number);

      this.maxAmountPerOption = selectOption.no.maxAmountPerOption;
      this.maxAmountPerBet = selectOption.no.maxAmountPerBet;
      this._selectOption = selectOption;
    }
  }

  /**
   * Get button option based on code
   * @param btnOptionCode
   * @returns {any}
   */
  getButtonOption(btnOptionCode): any {
    let buttonOption = this.btnOptions.find(btnOption => btnOption.code === btnOptionCode);
    return buttonOption;
  }

  /**
   * Reset all status to the beginning of the game
   */
  resetGame() {
    // Reset numbers status
    this.resetBetCoins(this.numbers);

    // Reset button options status
    this.resetBetCoins(this.btnOptions)

    // Reset total
    this.onTotalChanged.emit(0);
  }

  /**
   * Set active for a list of input numbers
   * @param numbers
   */
  setActiveNumbers(numbers) {
    if (numbers) {
      numbers.forEach(number => {
        if (number > 0 && number <= this.numbers.length) {
          this.addDefaultBetCoin(this.numbers[number - 1]);
        }
      });
    }
  }

  /**
   * Remove the last bet coin of input number
   * @param number
   */
  cancelSelectedNumber(number) {
    if (Number.isInteger(number) && number > 0 && number <= this.numbers.length) {
      this.numbers[number - 1].betCoins.pop();
    }
  }

  /**
   * Remove the last bet coin of input button options and its numbers
   * @param btnOptionCode
   */
  cancelSelectedButtonOption(btnOptionCode) {
    // Get button option based on code
    let btnOption = this.getButtonOption(btnOptionCode);
    if (btnOption) {
      // Remove the last bet coin of button option
      btnOption.betCoins.pop();
    }
  }

  /**
   * Remove a specific bets
   * @param bets
   */
  removeBets(bets) {
    bets.forEach(betValue => {
      if (Number.isInteger(betValue)) {
        this.cancelSelectedNumber(betValue);
      } else {
        this.cancelSelectedButtonOption(betValue);
      }
    });
  }

  /**
   * Get an option by its code
   * @param optionCode
   */
  getOptionByCode(optionCode): any {
    if (Number.isInteger(optionCode)) {
      return this.numbers[optionCode - 1];
    }

    return this.getButtonOption(optionCode);
  }

  /**
   * Set status of input number to active
   * @param number
   */
  setSelectedNumber(number) {
    if (number) {
      this.addDefaultBetCoin(number);

      // Set selected number to current bet
      this.setCurrentBets([number.value]);

      // Trigger popup
      this.onOptionSelected.emit();
      LotteryPage.clickPlay();
    }
  }

  /**
   * Set status of input button option to active
   * @param btnOption
   */
  setSelectedBtnOption(btnOption) {
    if (btnOption) {
      this.addDefaultBetCoin(btnOption);

      // Set button option code to current bet
      this.setCurrentBets([ btnOption.code ]);

      this.onOptionSelected.emit();
      LotteryPage.clickPlay();
    }
  }
}




// WEBPACK FOOTER //
// ./src/component/sixmark/49Numbers/sixMark49Numbers.ts